import * as React from 'react';
import { Section } from '../Section';

import * as styles from './styles.css';

interface IDesktopSimpleLayoutProps {
  gallery: React.ReactNode;
  loadMoreButton: React.ReactNode;
}

export const DesktopSimpleLayout: React.FC<IDesktopSimpleLayoutProps> = ({ gallery, loadMoreButton }) => {
  return (
    <div className={styles['desktop-layout']} data-testid="DesktopSimple">
      <div className={styles['desktop-content']}>
        <Section className={styles['gallery']} data-mark="gallery_construction_progress">
          {gallery}
          {loadMoreButton}
        </Section>
      </div>
    </div>
  );
};
